import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import { EventsView } from '@/views/Event/EventsView'
import { EventView } from '@/views/Event/EventView'

export const eventRoutes: RouteObject[] = [
  {
    path: 'event',
    label: 'Event',
    icon: STREAMING_MENU_ICONS.EVENT,
    platforms: [PLATFORM.DGE],
    children: [
      {
        index: true,
        element: <EventsView />,
        platforms: [PLATFORM.DGE]
      },
      {
        path: ':eventId',
        element: <EventView />,
        platforms: [PLATFORM.DGE]
      }
    ]
  }
]
